import React from 'react'
import PlanLimitScreen from 'src/screens/subscriptions/PlanLimitScreen'
import { useSelector } from 'react-redux'
import SendToXero from './SendToXero'
import useIsBlocked from 'src/hooks/useIsBlocked'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'

const XeroIntegration = () => {
  const blocked = useIsBlocked('xero-integration')

  if (blocked) {
    return <PermissionBlockScreen />
  }

  const usageLimits =
    useSelector(state => state.venue?.venue?.usageLimits) ?? {}
  const currentPlan = usageLimits?.currentPlan

  if (currentPlan === 'Free' || currentPlan === 'Starter') {
    return <PlanLimitScreen variant='xeroIntegration' />
  }

  return <SendToXero />
}

export default XeroIntegration
